import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
const reduxUser = useSelector((state) => state.user.user);

const storedUser = localStorage.getItem("user");
const token = localStorage.getItem("token");

const isLoggedIn = !!reduxUser || !!storedUser || !!token;
  const location = useLocation();

  const urlPortal = location.pathname.split("/")[1]; // bob, pnb, sagarsoft
  const storedPortal = localStorage.getItem("portal");

  // If portal is not in localStorage or doesn't match URL
  if (!storedPortal || storedPortal !== urlPortal) {
    localStorage.removeItem("portal");

    return (
      <Navigate
        to={`/${urlPortal}/login`}
        replace
      />
    );
  }

  // User not logged in
  if (!isLoggedIn) {
    return (
      <Navigate
        to={`/${urlPortal}/login`}
        state={{ from: location }}
        replace
      />
    );
  }

  return <Outlet />;
};

export default PrivateRoute;


















// import React from "react";
// import { Navigate, Outlet, useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";

// const PrivateRoute = () => {
//   const { user } = useSelector((state) => state.user);
//   const location = useLocation();

//   if (!user) {
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }

//   return <Outlet />;
// };

// export default PrivateRoute;
